import { all, put, takeEvery } from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import Auth from '@aws-amplify/auth';
import { exception } from 'circe/logger';
import { authClient, operatorClient } from 'domain/HttpClients';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { FORM_NAME } from './constants';

function* doCreate(context, action) {
  if (action.payload.name !== FORM_NAME) return;
  yield put(startSubmit(FORM_NAME));
  try {
    const {
      payload: { values },
    } = action;
    let tokens;
    let profileId;
    let accountId;
    const { role } = values;
    const currentLocalStorage = JSON.stringify(localStorage);
    try {
      const credentials = yield register({ ...values });
      tokens = yield login(credentials);
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    } finally {
      localStorage.clear();
      const data = JSON.parse(currentLocalStorage);
      Object.keys(data).forEach((k) => {
        localStorage.setItem(k, data[k]);
      });
    }
    try {
      const profileData = yield createProfile(values, tokens);
      profileId = profileData.profileId;
      accountId = profileData.accountId;
    } catch (e) {
      console.error(e);
      throw new Error(e.message);
    }
    yield activateProfile(profileId);
    yield put(reset(FORM_NAME));
    if (role === 'SHIPPER') {
      yield put(
        showNotification(
          I18n.str('shipperCreatedSuccessfully', 'Shipper Created Successfully'),
          'success',
        ),
      );
      context.history.push('/shippers');
    } else {
      yield put(
        showNotification(
          I18n.str('userCreatedSuccessfully', 'User Created Successfully'),
          'success',
        ),
      );
      context.history.push('/users');
    }
  } catch (e) {
    yield put(showNotification(e.message, 'error'));
    exception(e);
    console.error(e);
  } finally {
    yield put(stopSubmit(FORM_NAME));
  }
}

function* activateProfile(profileId) {
  const resp = yield operatorClient.Patch(`/api/profiles/${profileId}/activate`).send();
  return resp;
}
function* createProfile(values, tokens) {
  const headers = {
    Authorization: `Bearer ${tokens.idToken}`,
  };

  const {
    firstName, lastName, phone, address = 'Address', email = '', token, role,
  } = values;

  const data = {
    firstName,
    lastName,
    phone,
    address,
    email,
  };

  const self = yield authClient
    .Post('/api/self')
    .withHeaders(headers)
    .withData(data)
    .send();

  const params = {
    role,
    token: encodeURIComponent(token || DOMAIN_TOKEN),
  };
  const profile = yield authClient
    .Post('/api/self/profiles')
    .withHeaders(headers)
    .withParams(params)
    .send();
  return profile;
}

function* register(user) {
  const {
    phone, email, password, firstName, lastName, token,
  } = user;
  const name = `${firstName} ${lastName}`;
  try {
    yield Auth.signUp({
      username: email,
      password,
      attributes: {
        phone_number: phone,
        name,
        email,
        'custom:companyCode': token || DOMAIN_TOKEN,
        'custom:isIndividual': '1',
      },
    });
    return {
      email,
      password,
    };
  } catch (e) {
    throw new Error(e.message);
  }
}

function* login({ email, password }) {
  try {
    const resp = yield Auth.signIn(email, password);

    const { signInUserSession } = resp;
    const tokens = {
      accessToken: signInUserSession.accessToken.jwtToken,
      refreshToken: signInUserSession.refreshToken.token,
      idToken: signInUserSession.idToken.jwtToken,
    };
    return tokens;
  } catch (e) {
    throw new Error(e.message);
  }
}

function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doCreate, context)]);
}

export default watcher;
